import { axios } from '../util/axios'

const API_ENDPOINT_V2 = '/v2/accounts/changepassword'
const API_ENDPOINT_MY_V3 = '/v3/accounts/my/changepassword'

export const changePasswordWithTokenV2 = (token, password) =>
  axios
    .post(
      API_ENDPOINT_V2,
      { token, password },
      {
        withCredentials: true,
      }
    )
    .then(response => response.data)

export const changePasswordWithCurrentPasswordV3 = (currentPassword, password) =>
  axios
    .post(
      API_ENDPOINT_MY_V3,
      { currentPassword, newPassword: password },
      {
        withCredentials: true,
      }
    )
    .then(response => response.data)

export default (token, currentPassword, password) => {
  if (token) {
    return changePasswordWithTokenV2(token, password)
  }
  return changePasswordWithCurrentPasswordV3(currentPassword, password)
}
